import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'convertImage'})
export class ConvertImagePipe implements  PipeTransform {

  transform(value: any) {
    for (let i = 0; i < value.length; i++) {
      return value[i].replace('medium_oriented', 'large');
    }
  }
}
